import { render, staticRenderFns } from "./Defense.vue?vue&type=template&id=58c7e8b0&"
import script from "./Defense.vue?vue&type=script&lang=js&"
export * from "./Defense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports